<template>
    <div class="o-sk-services-modal-inner">
        <div class="sk-services-modal-inner-header">
            <div class="sk-services-modal-inner-icon-container">
                <img
                    class="sk-services-modal-inner-icon"
                    :src="icon"
                    :alt="name"
                >
            </div>
            <span class="sk-services-modal-inner-headline">
                {{ name }} ({{$t('ui.vid')}} {{floorInfo}})
            </span>
            <div v-if="distance" class="sk-services-modal-inner-distance-info">
                <span class="sk-services-modal-inner-guide-text">
                    {{ $t('ui.distance') }}:
                </span>
                <span class="sk-services-modal-inner-guide-distance">
                    {{ distanceText }}
                </span>
            </div>
        </div>
        <div class="sk-services-modal-inner-content">
            <template v-if="content">
                <div class="sk-services-modal-inner-content-title">
                    Beskrivning: 
                </div>
                <div class="sk-services-modal-inner-content-text" v-html="content" />
                <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc mollis eget odio vel sagittis. Pellentesque ligula quam, luctus ullamcorper convallis eget, feugiat vel quam. Donec diam urna, tempus ut ultrices ac, aliquet ac neque. Sed vel hendrerit est. Aenean dapibus tortor quam, a pellentesque augue faucibus non. Morbi molestie velit nec dui luctus sagittis.  amet ultrices.
                </div> -->
            </template>
            
            <template v-if="workingHours">
                <div class="sk-services-modal-inner-content-title sk-services-modal-inner-content-text--schedule">
                    Öppettider: 
                </div>
                <div class="sk-services-modal-inner-content-text" v-html="workingHours"/>
                <!-- Vardagar 10:00 - 20:00 <br/> Lördagar 10:00 - 19:00<br/> Söndagar 11:00 - 18:00 -->
                <!-- </div> -->
            </template>
            
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "OSKServicesModalInner",
    props: {
        service: {
            type: Object,
            required: true
        },
        distanceIcon: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getMap'
        ]),
        icon() {
            return this.t(this.service, 'icon') || '';
        },
        name() {
            return this.t(this.service, 'name') || '';
        },
        description() {
            return this.t(this.service, 'short_description') || '';
        },
        distance() {
            return this.t(this.service, 'distance') || '';
        },
        distanceText() {
            return `${this.distance} ${this.$t('ui.meter')}` || '';
        },
        floorInfo() {
            return this.t(this.service, 'floor') || '';
        },
        content() {
            return this.t(this.service, 'short_description', '') + this.t(this.service, 'content', '');
        },
        workingHours() {
            const openingHoursMode = this.service.meta.otg_use_opening_hours;
            //Store hours
            const storeOpeningHours = this.service.meta.working_hours_nb;
            if(openingHoursMode === 1 && Array.isArray(storeOpeningHours)){
                return storeOpeningHours.map((item, index) => (
                    {
                        weekDayNumber: item.openDay,
                        info: item.closed ?
                            `${item.openDayName}  Stengt` :
                            `${item.openDayName}  ${item.openPeriods[0]?.openTime} - ${item.openPeriods[0]?.closeTime}`
                    }
                ));
            }
            //Center hours
            const centerOpeningHours = this.getMap.meta.otg_opening_hours;

            if(openingHoursMode === 0 && Array.isArray(centerOpeningHours)){
                return centerOpeningHours.map((item, index) => {

                    return {
                        weekDayNumber: item.openDay,
                        info: item.closed ?
                            `${item.openDayName}  Stengt` :
                            `${item.openDayName}  ${item.openPeriods[0]?.openTime} - ${item.openPeriods[0]?.closeTime}`
                    };

                });
            }

            return '';
        },
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
